import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import RunSearchEffect from './RunSearchEffect'
import Channels from './Channels'
import PreSearchDataGuards from './guards/PreSearchDataGuards'
import PostSearchDataGuards from './guards/PostSearchDataGuards'

interface SocialWebChannelsWidgetProps {
  widgetId: number
}

const SocialWebChannelsWidget = ({ widgetId }: SocialWebChannelsWidgetProps) => (
  <UnexpectedErrorBoundary>
    <PreSearchDataGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <PostSearchDataGuards widgetId={widgetId}>
          <Channels widgetId={widgetId} />
        </PostSearchDataGuards>
      </RunSearchEffect>
    </PreSearchDataGuards>
  </UnexpectedErrorBoundary>
)

export default SocialWebChannelsWidget
